import { TPAComponentProps } from '../../types';

export enum AvatarSize {
  xLarge = 'xLarge',
  large = 'large',
  medium = 'medium',
  small = 'small',
  xSmall = 'xSmall',
  xxSmall = 'xxSmall',
}

export type ContentType = 'text' | 'placeholder' | 'image';

export interface AvatarProps extends Omit<AvatarBaseProps, 'size'> {
  /** Avatar's size. Optional. Defaults to 'medium'. One of 'xLarge' | 'large' | 'medium' | 'small' | 'xSmall' | 'xxSmall' . */
  size?: AvatarSize;
}

export enum ImageLoadStates {
  READY,
  LOADING,
  FAILURE,
}
export interface AvatarDefaultProps {
  size: AvatarSize;
}

export type TextType = 'initials' | 'plain';

/** ******** Base component **********/
export interface AvatarBaseProps extends TPAComponentProps {
  /** User's name. Optional. Used in a case when avatar image src is missing or is invalid. */
  name?: string;
  /** Avatar's image src. Optional. */
  src?: string;
  /** Avatar's image onLoad callback. Optional. */
  onLoad?: React.EventHandler<React.SyntheticEvent>;

  /** Define Avatar's text type. The text from the name prop would be displayed as initials or as plain text. */
  textType?: TextType;

  /** Define the initials' length.  This prop is relevant only for `textType` typed initials*/
  lettersLimit?: 1 | 2;
}
/** *************************/
